import React, { useEffect, useRef, useState } from 'react';
import type { FC } from 'react';
import styled from 'styled-components';

// Icon:
import Icon from '../../../../../../components/Icon';
import type { IResortList } from './Models/resort-list.model';

interface Props {
  className?: string;
  lists: IResortList[];
  linkedResortListTitle: string;
}

export const ResortListMobile: FC<Props> = (props) => {
  const { className, lists, linkedResortListTitle } = props;

  const [showAll, setShowAll] = useState(false);
  const handleShowMore = () => setShowAll(!showAll);
  const showMoreLabel = 'Показать все курорты';

  const containerRef = useRef<HTMLDivElement>(null);
  const [overflown, setOverflown] = useState(false);
  useEffect(() => {
    const isOverflown =
      lists.length +
        lists.reduce((acc, curr) => acc + curr.elements.length, 0) >
      6;
    setOverflown(isOverflown);
  }, [showAll]);

  const dummy: any = {};

  return (
    <>
      <StyledList
        className={className}
        overflown={overflown}
        showAll={showAll}
        ref={containerRef}
      >
        <StyledTitle>{linkedResortListTitle}</StyledTitle>
        {lists.map((list) => {
          const { name, elements } = list;
          if (!Array.isArray(elements) || !elements.length) return null;
          return (
            <>
              <StyledName>{name}</StyledName>
              {elements.map((item) => {
                const { link, text } = item;

                return (
                  <ListItem key={`${link}`}>
                    <Anchor href={link}>{text}</Anchor>
                  </ListItem>
                );
              })}
            </>
          );
        })}
      </StyledList>
      {!showAll ? (
        <StyledShowMore type="button" onClick={handleShowMore}>
          {showMoreLabel}
          <Icon type="arrow-down" {...dummy} />
        </StyledShowMore>
      ) : null}
    </>
  );
};

const StyledList = styled.div<{ overflown: boolean; showAll: boolean }>`
  margin-top: 8px;
  position: relative;
  max-height: ${({ showAll }) => (showAll ? 'initial' : '164px')};
  overflow: hidden;
`;

const StyledTitle = styled.h2`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;
`;

const StyledName = styled.p`
  margin-top: 8px;
  color: #4d4d4d;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
`;

const ListItem = styled.div`
  margin: 4px 0;
  display: flex;
  justify-content: space-between;
`;

const Anchor = styled.a`
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  color: #007aff;
`;

const StyledShowMore = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  text-align: left;
  color: #919499;
  background-color: transparent;
  border: none;

  svg {
    margin-left: 3px;
    width: 12px;
    height: 9px;
    transform: rotate(180deg);
  }
`;
